import { render, staticRenderFns } from "./StandaloneLayout.vue?vue&type=template&id=38b892ed&"
import script from "./StandaloneLayout.vue?vue&type=script&lang=js&"
export * from "./StandaloneLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports